<cap-beschreibung-table-wrapper>
  <span class="cap-table-wrapper-title" style="font-weight: bold">
    {{ "Gebaeude" | translate }}
  </span>

  <ng-container class="cap-table-wrapper-content">
    <cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        <div class="table-responsive">
          <table class="cap-table-detail">
            <thead>
              <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
            </thead>
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </cap-list-loader>
    <ng-template #tableHeaders>
      <tr>
        @if (avPlusErweiterung) {
          <th style="width: 5%">
            <cap-column-header [columnName]="'EGID'" [sortModel]="tableSortModel.columns.get('egid')"></cap-column-header>
          </th>
        } @else {
          <th style="width: 10%">
            <cap-column-header [columnName]="'EGID'" [sortModel]="tableSortModel.columns.get('egid')"></cap-column-header>
          </th>
        }
        @if (avPlusErweiterung) {
          <th style="width: 5%">
            <cap-column-header [columnName]="'gebaeude.BE-GID'" [sortModel]="tableSortModel.columns.get('be-egid')"></cap-column-header>
          </th>
        }
        @if (showVersichertenNummer) {
          <th style="width: 10%">
            <cap-column-header
              [columnName]="'VersicherungsNummerAbkürzung'"
              [sortModel]="tableSortModel.columns.get('versicherungsnummer')">
            </cap-column-header>
          </th>
        }
        <th style="width: 20%">
          <cap-column-header [columnName]="'Beschreibung'" [sortModel]="tableSortModel.columns.get('beschreibung')"></cap-column-header>
        </th>
        <th style="width: 20%">
          <cap-column-header [columnName]="'Adressen'" [sortModel]="tableSortModel.columns.get('adresse')"></cap-column-header>
        </th>
        <th class="text-end" style="width: 5%">
          <cap-column-header [columnName]="'Teilflaeche'" [sortModel]="tableSortModel.columns.get('teilflaeche')"></cap-column-header>
        </th>
        @if (showGesamtFlaeche) {
          <th class="text-end">
            <cap-column-header [columnName]="'Gesamtfläche'" [sortModel]="tableSortModel.columns.get('gesamtflaeche')"></cap-column-header>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template #tableRows>
      @if (listLoader?.items) {
        @for (gebaeudeMaster of listLoader?.items; track gebaeudeMaster) {
          @for (gebaeude of gebaeudeMaster.gebaeudeVersionsVm; track gebaeude) {
            @if (gebaeude.gebaeudeAufGrundstueckZuVersion.length !== 0) {
              @for (
                gebaeudeAufGrundstueckEntry of gebaeude.gebaeudeAufGrundstueckZuVersion | orderByErstellzeitpunkt;
                track gebaeudeAufGrundstueckEntry;
                let lastGebAufGrundstueck = $last
              ) {
                <tr>
                  <td
                    [capHistinfo]="serialHistInfos([gebaeude.model.histInfo, gebaeudeAufGrundstueckEntry.histInfo])"
                    class="gebaeudeRowProperty">
                    <cap-link
                      [enableNavigation]="hasRightToNavigateGebaeude"
                      [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                      [target]="navTargets.NAV_GEBAEUDE">
                      {{ gebaeude.model.gwrEgid }}
                    </cap-link>
                    <cap-gwr-link [egid]="gebaeude.model.gwrEgid?.toString()"></cap-gwr-link>
                  </td>
                  @if (avPlusErweiterung) {
                    <td
                      [capHistinfo]="serialHistInfos([gebaeude.model.histInfo, gebaeudeAufGrundstueckEntry.histInfo])"
                      class="gebaeudeRowProperty">
                      <cap-link [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)" [target]="navTargets.NAV_GEBAEUDE">
                        {{ gebaeude.model.kantGid }}
                      </cap-link>
                    </td>
                  }
                  @if (showVersichertenNummer) {
                    <td
                      [capHistinfo]="serialHistInfos([gebaeude.model.histInfo, gebaeudeAufGrundstueckEntry.histInfo])"
                      class="gebaeudeRowProperty">
                      <cap-link
                        [enableNavigation]="hasRightToNavigateGebaeude"
                        [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                        [target]="navTargets.NAV_GEBAEUDE">
                        {{ gebaeude.model.versicherungsNummer }}
                      </cap-link>
                    </td>
                  }
                  <td class="gebaeudeRowProperty">
                    <span [capHistinfo]="serialHistInfos([gebaeudeAufGrundstueckEntry.histInfo, gebaeude.model.histInfo])">
                      <cap-link
                        [enableNavigation]="hasRightToNavigateGebaeude"
                        [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                        [target]="navTargets.NAV_GEBAEUDE">
                        {{ gebaeude.model | kompaktGebaeudeMaster: gebaeudeAufGrundstueckEntry }}
                      </cap-link>
                    </span>
                    @if (!anzeigenAusSichtGeschaeft) {
                      <cap-kompakt-timepoint [item]="gebaeude.model.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
                    }
                    @if (gebaeude.showGeometrischerVerschnitt && lastGebAufGrundstueck && avPlusErweiterung) {
                      <div class="adresseEingerueckt">
                        {{ "geometrischAuf" | translate }}
                        <span>{{ gebaeude.anzahlLIG }} {{ "LIG" | translate }} / {{ gebaeude.anzahlSDR }} {{ "SDR" | translate }}</span>
                      </div>
                    }
                    @if (gebaeude.lastVisible && lastGebAufGrundstueck) {
                      <div class="adresseEingerueckt">
                        <cap-gebaeude-gehoert-zu-sdr
                          [gebaeude]="gebaeudeMaster.model"
                          [navigateTo]="navigateTo"></cap-gebaeude-gehoert-zu-sdr>
                      </div>
                    }
                  </td>
                  <td class="gebaeudeRowProperty">
                    @if (gebaeude.lastVisible && lastGebAufGrundstueck) {
                      @for (adresse of gebaeudeMaster.model.eingangAdressen; track adresse) {
                        <div>
                          @for (adressVersion of adresse.versions; track adressVersion) {
                            <div>
                              <span [capHistinfo]="adressVersion.histInfo">
                                <cap-link
                                  [enableNavigation]="hasRightToNavigateGebaeude"
                                  [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                                  [target]="navTargets.NAV_GEBAEUDE">
                                  {{ adressVersion | kompaktVersionGebaeudeeingangsadresse }}
                                </cap-link>
                              </span>
                              @if (!anzeigenAusSichtGeschaeft) {
                                <cap-kompakt-timepoint [item]="adressVersion.histInfo.bisTimePoint" loeschgeschaeft>
                                </cap-kompakt-timepoint>
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                  </td>
                  <td class="gebaeudeRowProperty">
                    @if (gebaeudeAufGrundstueckEntry?.flaecheQuadratmeter) {
                      <div class="text-end">
                        <span [capHistinfo]="gebaeudeAufGrundstueckEntry.histInfo">
                          {{ gebaeudeAufGrundstueckEntry?.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m²
                        </span>
                        @if (!anzeigenAusSichtGeschaeft && gebaeudeAufGrundstueckEntry?.flaecheQuadratmeter) {
                          <cap-kompakt-timepoint [item]="gebaeudeAufGrundstueckEntry.histInfo.bisTimePoint" loeschgeschaeft>
                          </cap-kompakt-timepoint>
                        }
                      </div>
                    }
                  </td>
                  @if (showGesamtFlaeche) {
                    <td class="gebaeudeRowProperty text-end" style="width: 1%">
                      @if (gebaeude.model?.totalQuadratmeter || gebaeude.model?.totalQuadratmeter === 0) {
                        <span [capHistinfo]="serialHistInfos([gebaeudeAufGrundstueckEntry.histInfo, gebaeude.model.histInfo])">
                          {{ gebaeude.model?.totalQuadratmeter | decimalHochkomma }}&nbsp;m²
                        </span>
                      }
                    </td>
                  }
                </tr>
              }
            }
            @else {
              <tr>
                <td
                  [capHistinfo]="serialHistInfos([gebaeude.model.histInfo, gebaeude.model.histInfo])"
                  class="gebaeudeRowProperty">
                  <cap-link
                    [enableNavigation]="hasRightToNavigateGebaeude"
                    [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                    [target]="navTargets.NAV_GEBAEUDE">
                    {{ gebaeude.model.gwrEgid }}
                  </cap-link>
                  <cap-gwr-link [egid]="gebaeude.model.gwrEgid?.toString()"></cap-gwr-link>
                </td>
                @if (avPlusErweiterung) {
                  <td
                    [capHistinfo]="serialHistInfos([gebaeude.model.histInfo, gebaeude.model.histInfo])"
                    class="gebaeudeRowProperty">
                    <cap-link [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                              [target]="navTargets.NAV_GEBAEUDE">
                      {{ gebaeude.model.kantGid }}
                    </cap-link>
                  </td>
                }
                @if (showVersichertenNummer) {
                  <td
                    [capHistinfo]="serialHistInfos([gebaeude.model.histInfo, gebaeude.model.histInfo])"
                    class="gebaeudeRowProperty">
                    <cap-link
                      [enableNavigation]="hasRightToNavigateGebaeude"
                      [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                      [target]="navTargets.NAV_GEBAEUDE">
                      {{ gebaeude.model.versicherungsNummer }}
                    </cap-link>
                  </td>
                }
                <td class="gebaeudeRowProperty">
                    <span [capHistinfo]="serialHistInfos([gebaeude.model.histInfo, gebaeude.model.histInfo])">
                      <cap-link
                        [enableNavigation]="hasRightToNavigateGebaeude"
                        [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                        [target]="navTargets.NAV_GEBAEUDE">
                        {{ gebaeude.model | kompaktGebaeudeMaster: gebaeude }}
                      </cap-link>
                    </span>
                  @if (!anzeigenAusSichtGeschaeft) {
                    <cap-kompakt-timepoint [item]="gebaeude.model.histInfo.bisTimePoint"
                                           loeschgeschaeft></cap-kompakt-timepoint>
                  }
                  @if (gebaeude.showGeometrischerVerschnitt && avPlusErweiterung) {
                    <div class="adresseEingerueckt">
                      {{ "geometrischAuf" | translate }}
                      <span>{{ gebaeude.anzahlLIG }} {{ "LIG" | translate }}
                        / {{ gebaeude.anzahlSDR }} {{ "SDR" | translate }}</span>
                    </div>
                  }
                  @if (gebaeude.lastVisible) {
                    <div class="adresseEingerueckt">
                      <cap-gebaeude-gehoert-zu-sdr
                        [gebaeude]="gebaeudeMaster.model"
                        [navigateTo]="navigateTo"></cap-gebaeude-gehoert-zu-sdr>
                    </div>
                  }
                </td>
                <td class="gebaeudeRowProperty">
                  @if (gebaeude.lastVisible) {
                    @for (adresse of gebaeudeMaster.model.eingangAdressen; track adresse) {
                      <div>
                        @for (adressVersion of adresse.versions; track adressVersion) {
                          <div>
                              <span [capHistinfo]="adressVersion.histInfo">
                                <cap-link
                                  [enableNavigation]="hasRightToNavigateGebaeude"
                                  [queryParams]="getQueryParams(gebaeudeMaster.model, gebaeude.model)"
                                  [target]="navTargets.NAV_GEBAEUDE">
                                  {{ adressVersion | kompaktVersionGebaeudeeingangsadresse }}
                                </cap-link>
                              </span>
                            @if (!anzeigenAusSichtGeschaeft) {
                              <cap-kompakt-timepoint [item]="adressVersion.histInfo.bisTimePoint" loeschgeschaeft>
                              </cap-kompakt-timepoint>
                            }
                          </div>
                        }
                      </div>
                    }
                  }
                </td>
                <td class="gebaeudeRowProperty">
                  @if (gebaeude?.model.totalQuadratmeter) {
                    <div class="text-end">
                        <span [capHistinfo]="gebaeude.model.histInfo">
                          {{ gebaeude?.model.totalQuadratmeter | decimalHochkomma }}&nbsp;m²
                        </span>
                      @if (!anzeigenAusSichtGeschaeft && gebaeude?.model.totalQuadratmeter) {
                        <cap-kompakt-timepoint [item]="gebaeude.model.histInfo.bisTimePoint" loeschgeschaeft>
                        </cap-kompakt-timepoint>
                      }
                    </div>
                  }
                </td>
                @if (showGesamtFlaeche) {
                  <td class="gebaeudeRowProperty text-end" style="width: 1%">
                    @if (gebaeude.model?.totalQuadratmeter || gebaeude.model?.totalQuadratmeter === 0) {
                      <span [capHistinfo]="serialHistInfos([gebaeude.model.histInfo, gebaeude.model.histInfo])">
                          {{ gebaeude.model?.totalQuadratmeter | decimalHochkomma }}&nbsp;m²
                        </span>
                    }
                  </td>
                }
              </tr>
            }
          }
        }
      }
    </ng-template>
  </ng-container>
</cap-beschreibung-table-wrapper>
